"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChapterState = void 0;
exports.ChapterState = {
    Default: "default",
    Converting: "converting",
};
